import { SET_USER_DISCLOSURES, REMOVE_USER_DISCLOSURES } from "../types";

export default function userDisclosures(state = {}, action = {}) {
  switch (action.type) {
    case SET_USER_DISCLOSURES: {
      return {
        ...state,
        userDisclosures: action.userDisclosures,
      };
    }
    case REMOVE_USER_DISCLOSURES:
      return { ...state, userDisclosures: undefined };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userDisclosures.js